import { NgModule } from '@angular/core';
import {  Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { SetupComponent } from './setup/setup.component';
import { Cerberus } from '@app/_helpers/Cerberus';
import { UserMaintenanceComponent } from './user-maintenance/user-maintenance.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [ 
      { path: 'login', component: LoginComponent },
      { path: 'setup', component: SetupComponent, canActivate:[Cerberus] },
      { path: 'user-maintenance', component: UserMaintenanceComponent, canActivate:[Cerberus] },
      { path: '**', component: UserMaintenanceComponent, canActivate:[Cerberus] }
    ]
  }, 
  {
      path: '**', component: LayoutComponent
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class AccountRoutingModule { }
